<div class="flex justify-content-center align-items-center h-full">
  <svg [attr.width]="width()" [attr.height]="height()" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.1668 0.833496L5.00016 10.0002L0.833496 5.8335" [attr.stroke]="stroke()" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</div>
